import {
    Container,
    Paper,
    Typography,
    Box,
    TextField,
    MenuItem,
    Button
} from "@mui/material";
import BackButtonSingle from "../../components/BackButtonSingle";
import styles from "../../styles/backButton.module.scss";
import btnStyles from '../../styles/buttons.module.scss';
export default function PersonalDetailsForm({

    data,

    errors,

    handleChange,

    onContinue

}) {

    return (



            <Paper
                elevation={3}
                sx={{
                    maxWidth: 1200,
                    mx: "auto",
                    mt: 4,
                    mb: 4,
                    px: { xs: 2, md: 4 },
                    py: 3,
                    borderRadius: 2
                }}
            >

                <Typography variant="h4" gutterBottom>

                    Job Application

                </Typography>

                <Typography
                    sx={{ mb: 4,color: "rgba(0,0,0,0.6)", }}
                >

                    Please complete your personal details below.

                </Typography>

                <Typography
                    variant="h6"
                    sx={{ mb: 2 }}
                >

                    Personal Details

                </Typography>

                <Box
                    sx={{
                        display: "grid",
                        gap: 2,
                        mb: 4,
                        gridTemplateColumns: {
                            xs: "1fr",
                            sm: "1fr",
                            md: "150px 1fr 1fr"
                        }
                    }}
                >

                    <TextField
                        select
                        label="Title"
                        name="title"
                        value={data.title}
                        onChange={handleChange}
                        error={!!errors.title}
                        helperText={errors.title}
                    >

                        <MenuItem value="Mr">Mr</MenuItem>
                        <MenuItem value="Mrs">Mrs</MenuItem>
                        <MenuItem value="Miss">Miss</MenuItem>
                        <MenuItem value="Ms">Ms</MenuItem>
                        <MenuItem value="Dr">Dr</MenuItem>

                    </TextField>

                    <TextField
                        label="First Name"
                        name="firstName"
                        value={data.firstName}
                        onChange={handleChange}
                        error={!!errors.firstName}
                        helperText={errors.firstName}
                    />

                    <TextField
                        label="Last Name"
                        name="lastName"
                        value={data.lastName}
                        onChange={handleChange}
                        error={!!errors.lastName}
                        helperText={errors.lastName}
                    />

                </Box>

                <Typography variant="h6" sx={{ mb: 2 }}>

                    Address

                </Typography>

                <Box
                    sx={{
                        display: "grid",
                        gap: 2,
                        mb: 4,
                        gridTemplateColumns: {
                            xs: "1fr",
                            md: "1fr 1fr"
                        }
                    }}
                >

                    <TextField
                        label="Address Line 1"
                        name="addressLine1"
                        value={data.addressLine1}
                        onChange={handleChange}
                        error={!!errors.addressLine1}
                        helperText={errors.addressLine1}
                    />

                    <TextField
                        label="Address Line 2"
                        name="addressLine2"
                        value={data.addressLine2}
                        onChange={handleChange}
                    />

                    <TextField
                        label="Town / City"
                        name="townCity"
                        value={data.townCity}
                        onChange={handleChange}
                        error={!!errors.townCity}
                        helperText={errors.townCity}
                    />

                    <TextField
                        label="County"
                        name="county"
                        value={data.county}
                        onChange={handleChange}
                        error={!!errors.county}
                        helperText={errors.county}
                    />

                    <TextField
                        label="Postcode"
                        name="postcode"
                        value={data.postcode}
                        onChange={handleChange}
                        error={!!errors.postcode}
                        helperText={errors.postcode}
                    />

                </Box>

                <Typography variant="h6" sx={{ mb: 2 }}>

                    Contact Details

                </Typography>

                <Box
                    sx={{
                        display: "grid",
                        gap: 2,
                        gridTemplateColumns: {
                            xs: "1fr",
                            md: "1fr 1fr"
                        }
                    }}
                >

                    <TextField
                        label="Mobile Number"
                        name="mobile"
                        value={data.mobile}
                        onChange={handleChange}
                        error={!!errors.mobile}
                        helperText={errors.mobile}
                    />

                    <TextField
                        label="Alternative Contact Number"
                        name="altContactNumber"
                        value={data.altContactNumber}
                        onChange={handleChange}
                         error={!!errors.altContactNumber}
                        helperText={errors.altContactNumber}
                    />

                    <TextField
                        label="Email Address"
                        name="emailAddress"
                        type="email"
                        value={data.emailAddress}
                        onChange={handleChange}
                        error={!!errors.emailAddress}
                        helperText={errors.emailAddress}
                    />

                    <TextField
                        label="Confirm Email Address"
                        name="confirmEmail"
                        type="email"
                        value={data.confirmEmail}
                        onChange={handleChange}
                        error={!!errors.confirmEmail}
                        helperText={errors.confirmEmail}
                    />

                </Box>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        width:"100%",
                        mt: 5
                    }}
                >
                    <BackButtonSingle text="Return to Job" sx={{  mt: "20px", mb: "20px"}}/>
                    <Button
                        className={btnStyles.btnDesktop}
                        variant="contained"
                        size="large"
                        sx={{ textTransform: 'none' }}
                        onClick={onContinue}
                    >
                        Continue
                    </Button>

                </Box>

            </Paper>

    );

}